(function () {
  if (window.__BRK_DYNAMIC_FIT_CARD__) return;
  window.__BRK_DYNAMIC_FIT_CARD__ = true;

  function parseJSON(text) {
    try {
      return JSON.parse(text || "{}");
    } catch (e) {
      return {};
    }
  }

  function normalize(value) {
    if (value === null || value === undefined) return "";
    return String(value).trim().toUpperCase().replace(/\s+/g, "_");
  }

  function splitList(raw) {
    if (!raw) return [];

    return String(raw)
      .split(/\r?\n|,/)
      .map(function (item) {
        return item.trim();
      })
      .filter(Boolean)
      .slice(0, 5);
  }

  function resolveSizeCode(rawSize, bandsMap) {
    var raw = normalize(rawSize);

    if (bandsMap[raw]) return raw;

    if (raw === "M") {
      if (bandsMap.M_WIDE) return "M_WIDE";
      if (bandsMap.M_SLIM) return "M_SLIM";
    }

    return "";
  }

  function valueMatchesBand(value, bandsMap) {
    return !!resolveSizeCode(value, bandsMap);
  }

  function getProductScope() {
    return (
      document.querySelector("variant-selects") ||
      document.querySelector("[data-product-form]") ||
      document.querySelector('form[action*="/cart/add"]') ||
      document
    );
  }

  function getSelectedSizeFromCheckedInputs(bandsMap) {
    var scope = getProductScope();
    var checked = scope.querySelectorAll('input[type="radio"]:checked');

    for (var i = 0; i < checked.length; i++) {
      var value = checked[i].value;

      if (valueMatchesBand(value, bandsMap)) {
        return value;
      }
    }

    return "";
  }

  function getSelectedSizeFromActiveButtons(bandsMap) {
    var scope = getProductScope();

    var selectors = [
      '[aria-pressed="true"]',
      '[aria-checked="true"]',
      '[data-selected="true"]',
      ".is-selected",
      ".selected",
      ".active",
      ".swatch__button--selected",
      ".radio__button--selected"
    ];

    var candidates = scope.querySelectorAll(selectors.join(","));

    for (var i = 0; i < candidates.length; i++) {
      var el = candidates[i];

      var value =
        el.getAttribute("value") ||
        el.getAttribute("data-value") ||
        el.getAttribute("data-option-value") ||
        el.textContent ||
        "";

      value = value.trim();

      if (valueMatchesBand(value, bandsMap)) {
        return value;
      }
    }

    return "";
  }

  function getSelectedSizeFromVisibleOptionText(bandsMap) {
    var scope = getProductScope();
    var candidates = scope.querySelectorAll("label, button, span, div");

    for (var i = 0; i < candidates.length; i++) {
      var el = candidates[i];

      if (!el.offsetParent) continue;

      var text = (el.textContent || "").trim();

      if (!text || text.length > 4) continue;
      if (!valueMatchesBand(text, bandsMap)) continue;

      var isSelected =
        el.getAttribute("aria-pressed") === "true" ||
        el.getAttribute("aria-checked") === "true" ||
        el.getAttribute("data-selected") === "true" ||
        /\b(is-selected|selected|active)\b/.test(el.className || "");

      var inputId = el.getAttribute("for");
      var input = inputId ? document.getElementById(inputId) : null;

      if ((input && input.checked) || isSelected) {
        return text;
      }
    }

    return "";
  }

  function getVariantSizeFallback(card, bandsMap) {
    var variantsEl = card.querySelector('script[data-brk-fit-variants]');
    if (!variantsEl) return "";

    var payload = parseJSON(variantsEl.textContent);

    var sizeOptionIndex = 2;
    var items = payload;

    if (payload.items) {
      sizeOptionIndex = payload.size_option_index || 2;
      items = payload.items;
    }

    var form =
      document.querySelector("[data-product-form]") ||
      document.querySelector('form[action*="/cart/add"]');

    if (!form) return "";

    var idInput = form.querySelector('input[name="id"]');
    if (!idInput || !idInput.value) return "";

    var variant = items[String(idInput.value)];
    if (!variant) return "";

    var value =
      variant["option" + sizeOptionIndex] ||
      variant.option2 ||
      variant.option1 ||
      variant.option3 ||
      "";

    return valueMatchesBand(value, bandsMap) ? value : "";
  }

  function getSelectedSize(card, bandsMap) {
    return (
      getSelectedSizeFromCheckedInputs(bandsMap) ||
      getSelectedSizeFromActiveButtons(bandsMap) ||
      getSelectedSizeFromVisibleOptionText(bandsMap) ||
      getVariantSizeFallback(card, bandsMap)
    );
  }

  function renderBreeds(card, band) {
    var breedsEl = card.querySelector("[data-brk-fit-breeds]");
    if (!breedsEl) return;

    var labelText =
      breedsEl.getAttribute("data-brk-fit-breeds-label") ||
      breedsEl.dataset.brkFitBreedsLabel ||
      "";

    var raw =
      band.breed_examples_raw ||
      band.breed_examples ||
      band.breed_logic ||
      "";

    var breeds = splitList(raw);

    if (!breeds.length) {
      breedsEl.hidden = true;
      breedsEl.textContent = "";
      return;
    }

    breedsEl.hidden = false;
    breedsEl.innerHTML = "";

    if (labelText) {
      var label = document.createElement("span");
      label.textContent = labelText + ":";
      breedsEl.appendChild(label);
      breedsEl.appendChild(document.createTextNode(" "));
    }

    breedsEl.appendChild(document.createTextNode(breeds.join(", ")));
  }

  function renderNote(card, band) {
    var noteEl = card.querySelector("[data-brk-fit-note]");
    if (!noteEl) return;

    var fallback =
      noteEl.getAttribute("data-brk-fit-note-fallback") ||
      noteEl.dataset.brkFitNoteFallback ||
      noteEl.textContent ||
      "";

    noteEl.textContent = band.fit_note || band.note || fallback;
  }

  function updateCard(card) {
    var bandsEl = card.querySelector('script[data-brk-fit-bands]');
    if (!bandsEl) return;

    var bandsMap = parseJSON(bandsEl.textContent);
    var selectedSize = getSelectedSize(card, bandsMap);
    var sizeCode = resolveSizeCode(selectedSize, bandsMap);

    if (!sizeCode) return;

    var band = bandsMap[sizeCode];
    if (!band) return;

    var sizeEl = card.querySelector("[data-brk-fit-size]");
    var rangeEl = card.querySelector("[data-brk-fit-range]");
    var widthEl = card.querySelector("[data-brk-fit-width]");

    var displaySize = band.display_size || String(sizeCode).split("_")[0] || "";

    var rangeText =
      band.min !== "" &&
      band.max !== "" &&
      band.min !== null &&
      band.max !== null &&
      band.min !== undefined &&
      band.max !== undefined
        ? band.min + "–" + band.max + " cm"
        : "—";

    if (sizeEl) sizeEl.textContent = displaySize;
    if (rangeEl) rangeEl.textContent = rangeText;
    if (widthEl) widthEl.textContent = band.width_label || "";

    renderBreeds(card, band);
    renderNote(card, band);
  }

  function updateAll() {
    document.querySelectorAll("[data-brk-fit-card]").forEach(updateCard);
  }

  function scheduleUpdate() {
    window.requestAnimationFrame(updateAll);
    setTimeout(updateAll, 50);
    setTimeout(updateAll, 150);
    setTimeout(updateAll, 350);
    setTimeout(updateAll, 700);
  }

  document.addEventListener(
    "click",
    function (event) {
      if (
        event.target &&
        (
          event.target.closest("variant-selects") ||
          event.target.closest("[data-product-form]") ||
          event.target.closest('form[action*="/cart/add"]') ||
          event.target.closest("fieldset")
        )
      ) {
        scheduleUpdate();
      }
    },
    true
  );

  document.addEventListener(
    "change",
    function (event) {
      if (
        event.target &&
        (
          event.target.closest("variant-selects") ||
          event.target.closest("[data-product-form]") ||
          event.target.closest('form[action*="/cart/add"]') ||
          event.target.closest("fieldset")
        )
      ) {
        scheduleUpdate();
      }
    },
    true
  );

  document.addEventListener(
    "input",
    function (event) {
      if (
        event.target &&
        (
          event.target.closest("variant-selects") ||
          event.target.closest("[data-product-form]") ||
          event.target.closest('form[action*="/cart/add"]') ||
          event.target.closest("fieldset")
        )
      ) {
        scheduleUpdate();
      }
    },
    true
  );

  var variantRoot =
    document.querySelector("variant-selects") ||
    document.querySelector("[data-product-form]") ||
    document.querySelector('form[action*="/cart/add"]');

  if (variantRoot) {
    var observer = new MutationObserver(scheduleUpdate);

    observer.observe(variantRoot, {
      attributes: true,
      childList: true,
      subtree: true,
      attributeFilter: [
        "class",
        "aria-pressed",
        "aria-checked",
        "checked",
        "value",
        "data-selected"
      ]
    });
  }

  scheduleUpdate();
})();